module.exports = __webpack_public_path__ + "img/success.dd4e0172.png";